import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
// react plugin for creating charts
// import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import CheckBoxOutlineBlankRounded from "@material-ui/icons/CheckBoxOutlineBlankRounded";
// import Warning from "@material-ui/icons/Warning";
// import DateRange from "@material-ui/icons/DateRange";
// import LocalOffer from "@material-ui/icons/LocalOffer";
// import Update from "@material-ui/icons/Update";
import AccountBalance from "@material-ui/icons/AccountBalance";
// import ArrowUpward from "@material-ui/icons/ArrowUpward";
// import AccessTime from "@material-ui/icons/AccessTime";
// import Accessibility from "@material-ui/icons/Accessibility";
// import BugReport from "@material-ui/icons/BugReport";
// import Code from "@material-ui/icons/Code";
// import Cloud from "@material-ui/icons/Cloud";
import Group from "@material-ui/icons/Group";
import LocationCity from "@material-ui/icons/LocationCity";
import Person from "@material-ui/icons/Person";
// import ShowChart from "@material-ui/icons/ShowChart";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Table from "components/Table/Table.js";
// import Tasks from "components/Tasks/Tasks.js";
// import CustomTabs from "components/CustomTabs/CustomTabs.js";
// import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
// import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

// import { bugs, website, server } from "variables/general.js";

// import {
//   // dailySalesChart,AdminCheckdata
//   // emailsSubscriptionChart,
//   // completedTasksChart,
// } from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/AdmindashboardStyle.js";
// import { Icon } from "@material-ui/core";

const useStyles = makeStyles(styles);

import { Form, Row, Col, Button } from "react-bootstrap";
// Import Service
import RegsugarService from "../services/regsugar.service";
// import OcsbService from "../services/ocsb.service";
// import authService from "../services/auth.service";
import dashboardService from "../services/dashboard.service";
import TimeregService from "../services/timereg.service";
import LoadingAlert from "components/LoadingAlert";

export default function RegistrarDashboard() {
  const [timeregList, setTimeregList] = useState([]);
  const [timeregSelect, setTimeregSelect] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [assocmember, setAssocmember] = useState([]);

  const approveNumber = data.filter(function (element) {
    return element.approve_status == "อนุมัติ";
  });
  const notApproveNumber = data.filter(function (element) {
    return element.approve_status == "ไม่อนุมัติ";
  });
  const waitApproveNumber = data.filter(function (element) {
    return element.approve_status == "รออนุมัติ";
  });
  const documentApproveNumber = data.filter(function (element) {
    return element.approve_status == "ขอเอกสาร";
  });
  // const user = authService.getCurrentUser();
  const getData = (timereg_id) => {
    if (timereg_id == 0) {
      setData([]);
    } else {
      setLoading(true);
      RegsugarService.getRegsugarFrontPage(timereg_id)
        .then((response) => {
          setData(response.data.data);
        })
        .catch((error) => {
          console.error("error fetching data: ", error);
          setError(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const getAssocmember = () => {
    setLoading(true);
    dashboardService
      .getFrontpageDashboard()
      .then((response) => {
        // console.log(response.data.data);
        setAssocmember(response.data.data[0]);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleTimeregChange = (e) => {
    setTimeregSelect(e.target.value);
    getData(e.target.value);
  };
  const getTimeRegList = () => {
    TimeregService.getTimeRegAll()
      .then((response) => {
        setTimeregList(response.data.data);
      })
      .catch((err) => {
        console.log("fetch timereg List Error :" + err);
      });
  };

  useEffect(() => {
    getTimeRegList();
    getAssocmember();
  }, []);

  // const checkStatus = (length) => {
  //   if (length > 10) return "success";
  //   if (length > 5) return "warning";
  //   if (length > 0) return "error";
  // };
  const SearchStatusComponent = () => {
    const [searchStatus, setSearchStatus] = useState("");
    const [birthDay, setBirthDay] = useState("");
    const [error, setError] = useState(false);
    const [errorMassage, setErrorMassage] = useState("");
    const [resultSearch, setResultSearch] = useState({
      name: null,
      farmer: null,
      farmer_master: null,
    });
    const handleIdChange = (e) => {
      setSearchStatus(e.target.value);
      setError(false);
      setResultSearch({
        name: null,
        farmer: null,
        farmer_master: null,
      });
    };
    const handleBirthDayChange = (e) => {
      setBirthDay(e.target.value);
      setError(false);
      setResultSearch({
        name: null,
        farmer: null,
        farmer_master: null,
      });
    };
    const ClickSearch = () => {
      RegsugarService.searchStatus({ idcard: searchStatus, birthday: birthDay })
        .then((result) => {
          setResultSearch(result.data);
          setError(false);
        })
        .catch((er) => {
          setError(true);
          setErrorMassage(er.response.data.message);
          setResultSearch({
            name: null,
            farmer: null,
            farmer_master: null,
          });
        });
    };
    return (
      <>
        <Row>
          <Col md={5}>
            <Form.Group
              controlId="formBasicText"
              // validationState={checkStatus(searchStatus.length)}
            >
              {/* <Form.Label>Working example with validation</Form.Label> */}
              <Form.Control
                className="mb-3"
                type="number"
                value={searchStatus}
                placeholder="หมายเลขบัตรประชาชน"
                onChange={handleIdChange}
                isInvalid={error}
              />
              <Form.Control.Feedback type="invalid">
                {errorMassage}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={5}>
            <Form.Group
              controlId="formBasicText"
              // validationState={checkStatus(searchStatus.length)}
            >
              {/* <Form.Label>Working example with validation</Form.Label> */}
              <Form.Control
                className="mb-3"
                type="text"
                value={birthDay}
                placeholder="วันเกิด เช่น 2528-02-18"
                onChange={handleBirthDayChange}
                isInvalid={error}
              />
              {/* <Form.Control.Feedback type="invalid">
                {errorMassage}
              </Form.Control.Feedback> */}
            </Form.Group>
          </Col>
          <Col md={2}>
            <Button
              style={{ padding: "0.5rem", margin: 0, width: "100%" }}
              onClick={ClickSearch}
            >
              ค้นหา
            </Button>
          </Col>
        </Row>
        <Row hidden={resultSearch.name == null ? true : false}>
          <p>{resultSearch.name}</p>
          <p>
            สถานะ หน.กลุ่มชาวไร่อ้อย :{" "}
            {resultSearch.farmer_master &&
            resultSearch.farmer_master.status_text == "หน. กลุ่ม" ? (
              <span style={{ color: "green" }}>
                เป็น หน.กลุ่ม{" "}
                {"- เลขบัตร " + resultSearch.farmer_master.farmer_card}
              </span>
            ) : (
              <span style={{ color: "red" }}>ไม่เป็น หน.กลุ่ม</span>
            )}
          </p>
          <p>
            สถานะ ชาวไร่อ้อย :{" "}
            {resultSearch.farmer &&
            resultSearch.farmer.status_text == "ชาวไร่" ? (
              <span style={{ color: "green" }}>
                เป็น ชาวไร่ {"- เลขบัตร " + resultSearch.farmer.farmer_card_id}
              </span>
            ) : (
              <span style={{ color: "red" }}>ไม่เป็น ชาวไร่</span>
            )}
          </p>
        </Row>
      </>
    );
  };

  const classes = useStyles();
  if (error) return `Error :${error}`;

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>ค้นหาสถานะชาวไร่อ้อย</Accordion.Header>
        <Accordion.Body>
          <SearchStatusComponent />
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>Dashboard</Accordion.Header>
        <Accordion.Body>
          <div>
            {loading ? <LoadingAlert /> : ""}
            <Row>
              <Form.Label column sm={4}>
                รอบการจดทะเบียน :
              </Form.Label>
              <Col md={8}>
                <Form.Group>
                  <Form.Select
                    name="approve_status"
                    value={timeregSelect}
                    onChange={handleTimeregChange}
                  >
                    <option value="0">เลือกรอบที่จดทะเบียน</option>
                    {timeregList.map((a) => (
                      <option key={a.timereg_id} value={a.timereg_id}>
                        {a.timereg_desc}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <GridContainer>
              <GridItem xs={12} sm={6} md={3}>
                <Card>
                  <CardHeader color="success" stats icon>
                    <CardIcon color="success">
                      {/* <Icon>{Person}</Icon> */}
                      <Person />
                    </CardIcon>
                    <p className={classes.cardCategory}>อนุมัติ</p>
                    <h3 className={classes.cardTitle}>
                      {approveNumber.length.toLocaleString("en-US")}{" "}
                      <small>คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  Get more space
                </a> */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <Card>
                  <CardHeader color="danger" stats icon>
                    <CardIcon color="danger">
                      <Person />
                    </CardIcon>
                    <p className={classes.cardCategory}>ไม่อนุมัติ</p>
                    <h3 className={classes.cardTitle}>
                      {notApproveNumber.length.toLocaleString("en-US")}{" "}
                      <small>คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <Card>
                  <CardHeader color="warning" stats icon>
                    <CardIcon color="warning">
                      <Person />
                    </CardIcon>
                    <p className={classes.cardCategory}>รออนุมัติ</p>
                    <h3 className={classes.cardTitle}>
                      {waitApproveNumber.length.toLocaleString("en-US")}{" "}
                      <small>คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <Card>
                  <CardHeader color="info" stats icon>
                    <CardIcon color="info">
                      <Person />
                    </CardIcon>
                    <p className={classes.cardCategory}>ขอเอกสาร</p>
                    <h3 className={classes.cardTitle}>
                      {documentApproveNumber.length.toLocaleString("en-US")}{" "}
                      <small>คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
            <h4>สรุปภาพรวม</h4>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <Card>
                  <CardHeader color="primary" stats icon>
                    <CardIcon color="primary">
                      <AccountBalance />
                    </CardIcon>
                    <p className={classes.cardCategory}>สมาคม</p>
                    <h3 className={classes.cardTitle}>
                      {assocmember.associations
                        ? parseInt(assocmember.associations).toLocaleString(
                            "en"
                          )
                        : "-"}
                      <small> แห่ง</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <Card>
                  <CardHeader color="warning" stats icon>
                    <CardIcon color="warning">
                      <LocationCity />
                    </CardIcon>
                    <p className={classes.cardCategory}>โรงงาน</p>
                    <h3 className={classes.cardTitle}>
                      {assocmember.factories
                        ? parseInt(assocmember.factories).toLocaleString("en")
                        : "-"}
                      <small> แห่ง</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
            <h6>การเป็นชาวไร่</h6>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <Card>
                  <CardHeader color="info" stats icon>
                    <CardIcon color="info">
                      <Group />
                    </CardIcon>
                    <p className={classes.cardCategory}>ชาวไร่</p>
                    <h3 className={classes.cardTitle}>
                      {assocmember.farmerall
                        ? parseInt(assocmember.farmerall).toLocaleString("en")
                        : "-"}
                      <small> คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <Card>
                  <CardHeader color="danger" stats icon>
                    <CardIcon color="danger">
                      <Group />
                    </CardIcon>
                    <p className={classes.cardCategory}>เสียชีวิต</p>
                    <h3 className={classes.cardTitle}>
                      {assocmember.farmerdead
                        ? parseInt(assocmember.farmerdead).toLocaleString("en")
                        : "-"}
                      <small> คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
            <h6>การเป็นหัวหน้ากลุ่ม</h6>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <Card>
                  <CardHeader color="info" stats icon>
                    <CardIcon color="info">
                      <Person />
                    </CardIcon>
                    <p className={classes.cardCategory}>หัวหน้ากลุ่ม</p>
                    <h3 className={classes.cardTitle}>
                      {assocmember.groupheadall
                        ? parseInt(assocmember.groupheadall).toLocaleString(
                            "en"
                          )
                        : "-"}
                      <small> คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <Card>
                  <CardHeader color="danger" stats icon>
                    <CardIcon color="danger">
                      <Person />
                    </CardIcon>
                    <p className={classes.cardCategory}>เสียชีวิต</p>
                    <h3 className={classes.cardTitle}>
                      {assocmember.groupheaddead
                        ? parseInt(assocmember.groupheaddead).toLocaleString(
                            "en"
                          )
                        : "-"}
                      <small> คน</small>
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      {/* <DateRange />
                Last 24 Hours */}
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
